import * as React from 'react';

const SVGComponent = (props) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={29} height={29} {...props}>
    <g data-name="Group 2361" transform="translate(-222 -508)">
      <rect
        data-name="Rectangle 835"
        width={29}
        height={29}
        rx={10}
        transform="translate(222 508)"
        style={{
          fill: '#1a1f3f'
        }}
      />
    </g>
    <path
      data-name="Path 5526"
      d="M1700.256 159.4v7.968a2.348 2.348 0 0 1-1.643 2.349 2.759 2.759 0 0 1-.8.119q-3.727.013-7.456 0a2.364 2.364 0 0 1-2.453-2.443c-.006-2.234 0-4.468 0-6.7v-9.3a2.309 2.309 0 0 1 1.391-2.256 2.422 2.422 0 0 1 .984-.218c2.533-.018 5.066-.015 7.6-.007a2.363 2.363 0 0 1 2.382 2.451q.001 4.023-.005 8.037zm-10.444-7.615v13.283h8.535v-13.282zm4.263 14.256a1.424 1.424 0 1 0 1.428 1.431 1.434 1.434 0 0 0-1.427-1.43z"
      transform="translate(-1679.899 -144.914)"
      style={{
        fill: '#fff'
      }}
    />
  </svg>
);

export default SVGComponent;
